/* 
Object:         User Profile
Description:    Logic and events for the module User Profile
Used in:        UserProfile
*/

import * as appsettings from "../appsettings";

/**
* Init (binding button actions)
*/
export function initialize(): void { }

/**
* logout
*/
export function logout(): void {
    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("Account/Logout"),
        success: function () {
            window.location.assign(appsettings.getLocalUrl("Account/Login"));
        }
    });
}
